import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IonicBaseComponent } from '@front-end/core/ionic-hooks';
import { IonSegment } from '@ionic/angular';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RouterHelperService } from '@libs/ui/uikit';

@Component({
  template: '',
})
export abstract class IonicAbstractTabComponent
  extends IonicBaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('tabs') tabs?: IonSegment;
  private routerSubscription?: Subscription;
  private viewInitialized = false;
  private pendingState?: string;

  constructor(
    protected router: Router,
    protected routerHelperService: RouterHelperService
  ) {
    super();
  }

  ngOnInit(): void {
    this.routerSubscription = this.routerHelperService.routerData
      .pipe(this.untilPageActive())
      .subscribe((data) => {
        const state = data['state'];

        if (!this.viewInitialized) {
          this.pendingState = state;
          return;
        }

        this.updateTabState(state);
      });
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;

    if (this.pendingState) {
      setTimeout(() => {
        this.updateTabState(this.pendingState);
        this.pendingState = undefined;
      }, 0);
    }
  }

  private updateTabState(state?: string): void {
    if (this.tabs && state && this.getHandledStates().includes(state)) {
      this.tabs.value = state;
      return;
    }

    if (state) {
      console.warn(
        `Invalid state for ${this.getBaseRoute()}: expected one of ${this.getHandledStates()} but got ${state}`
      );
    }
  }

  onTabUpdate(event: Event): void {
    const selectedTab = (event as CustomEvent).detail.value;
    const route = this.getRouteForTab(selectedTab);
    this.router.navigate(['/home', this.getBaseRoute(), route]);
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  protected abstract getHandledStates(): string[];
  protected abstract getRouteForTab(tab: string): string;
  protected abstract getBaseRoute(): string;
}
